import Papa from 'papaparse';

export type ExportRow = Record<string, string | number | boolean | null | undefined>;

/**
 * Generates CSV content from headers and rows using PapaParse for enhanced security.
 */
export function generateCSV(headers: string[], rows: ExportRow[], columnIds: string[]): string {
  const data = [headers, ...rows.map((row) => columnIds.map((id) => row[id] ?? ''))];

  return Papa.unparse(data, {
    escapeFormulae: true,
    quotes: true,
    quoteChar: '"',
    delimiter: ',',
    header: false,
  });
}
